import React, { useState, useCallback } from "react";
import Loader from "../components/loader/Loader";

const useFullPageLoader = (type) => {
  const [loading, setLoading] = useState(false);
  const showLoader = useCallback(() => setLoading(true), []);
  const hideLoader = useCallback(() => setLoading(false), []);

  return [
    loading ? <Loader status={loading} type={type} /> : null,
    showLoader,
    hideLoader,
  ];
};

export default useFullPageLoader;
